import { render, staticRenderFns } from "./dingtalk.vue?vue&type=template&id=583b4d52&scoped=true&"
import script from "./dingtalk.vue?vue&type=script&lang=js&"
export * from "./dingtalk.vue?vue&type=script&lang=js&"
import style0 from "./dingtalk.vue?vue&type=style&index=0&id=583b4d52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583b4d52",
  null
  
)

component.options.__file = "dingtalk.vue"
export default component.exports